<template>
  <div>
    <auto-suggest
      class="flex-grow-1"
      icon="mdi-text-box-search-outline"
      :showAddButton="false"
      v-model="selectedStaff"
      @search="lookupStaff"
      @input="staffChanged"
      suggestionText="name"
      suggestionValue="id"
      return-object
      label="Lookup staff using first or last name"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import AutoSuggest from "@/components/common/AutoSuggest.vue";
export default {
  props: {
    value: {
      type: [Number, String, Object],
      required: false,
      default: null
    }
  },
  data: () => {
    return { 
      selectedStaff: null
    }
  },
  created(){
    this.selectedStaff = this.value;
  },
  computed: {
    ...mapGetters("staff", ["staffProcessed", "getStaff"])
  },
  methods: {
    ...mapActions("staff", ["fetchStaff"]),

    lookupStaff(query, callback) {
      const params = {
        page: 0,
        size: 10000,
        sort: "firstName"
      };
      if (query) {
        params["firstName"] = query;
        params["lastName"] = query;
      }
      this.fetchStaff(params)
        .then(response => {
          if (response) {
            const staff = response.content;
            if (staff && staff.length > 0) {
              staff.forEach(s => {
                s.name = `${s.firstName} - ${s.lastName}`;
              });
            }
            callback(staff);
          }
        })
        .catch(error => {
          this.addErrorMessage("Server response with error " + error);
          callback([]);
        });
    },
    staffChanged(staff){
      this.$emit('input', staff);
    }
  },
  components: { AutoSuggest }
};
</script>

<style></style>
